<template>
  <div id="app">
    <header>
      <div class="row-1">
        <img :src="'static/img/logo_'+$i18n.locale+'.svg'" alt="SAAMP Logo" class="logo">
      </div>
      <div class="row-2">
        <h1>{{ $t('message.title') }}</h1>
      </div>
    </header>
    <main>
      <router-view></router-view>
    </main>
    <!--<footer>
      <ul>
        <li><button v-on:click="switchLocale('fr')">FR</button></li>
        <li><button v-on:click="switchLocale('en')">EN</button></li>
        <li><button v-on:click="switchLocale('pl')">PL</button></li>
      </ul>
    </footer>-->
  </div>
</template>

<script>
export default {
  name: 'app',
  methods: {
    switchLocale: function (locale) {
      this.$i18n.locale = locale
    }
  }
}
</script>

<style>
html {
  font-size: 14px;
}

@media screen and (min-width: 370px) {
  html {
    font-size: 15px;
  }
}

@media screen and (min-width: 600px) {
  html {
    font-size: 16px;
  }
}

body {
  margin: 0;
}

h1, h2, h3 {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, 'Nimbus Sans', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

header {
}

header .row-1, header .row-2 {
  padding: 0 20px;
}

header .row-1 {
  padding-top: 10px;
  padding-bottom: 10px;
}

header .logo {
  max-height: 4rem;
  max-width: 100%;
}

header .row-2 {
  background-color: #c87831;
  color: white;
}

header h1 {
  font-size: 1.2rem;
  line-height: 4rem;
  font-weight: normal;
}

main {
  flex: 1;
  text-align: center;
  background: linear-gradient(to top left, #ce8942, #ead3a1); /*Standard*/
}

@media screen and (orientation: landscape) and (max-height: 440px) {
  header {
    display: none;
  }
}
@media screen and (orientation: portrait) and (max-width: 380px) {
  header .row-1 {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  header .logo {
    max-height: 3rem;
    max-width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue